export const EVENT = {
  name: "Million Dollar Shot",
  registered: "®",
  tagline: "An Inaugural Evening Under the Stars",
  subtitle: "Where Investment Meets Impact",
  date: "Saturday, November 14, 2026",
  dateShort: "11.14.26",
  time: "5:30 to 9:30 PM",
  venue: "The Club at Renaissance",
  city: "Fort Myers, Florida",
  guests: "300 Guests",
  beneficiary: "Naples Cancer Advisors",
  ticketsOpen: "Table & Individual Seat Reservations Open to the Public Monday, June 1, 2026",
};

// External links — placeholders until client provides live URLs.
export const LINKS = {
  tickets: "#tickets",
  tables: "#tickets",
  donate: "#fundraising",
  contactEmail: "nikki@naplescanceradvisors.org",
  eventsEmail: "events@naplescanceradvisors.org",
  phone: "239.846.2273",
  deckPdf: "/deck/million-dollar-shot-sponsorship.pdf",
};

export const STARLIGHT_HEADLINE = [
  "Join Us Under the Stars",
  "for the Inaugural Million Dollar Shot",
  "Black Tie Gala",
];

export const STARLIGHT_QUOTE =
  "Experience an unforgettable evening at The Club at Renaissance alongside Southwest Florida's most influential leaders and philanthropists, where purpose inspires generosity and every moment leads to the ";

export const EVENING_FLOW = [
  {
    no: "I",
    title: "The Welcome",
    body: "A curated arrival with live music, premium spirits and refined activations as guests gather beneath the palms at dusk.",
  },
  {
    no: "II",
    title: "Dinner Under the Stars",
    body: "An elegant seated dinner on the terrace as the evening softens into a canopy of starlight over The Club at Renaissance.",
  },
  {
    no: "III",
    title: "The Million Dollar Shot",
    body: "The signature moment of the evening — select guests, drawn at random, each take a single shot with one million dollars on the line.",
  },
  {
    no: "IV",
    title: "The Mission Moment",
    body: "A seated program of purpose — a fund-a-need, live auction and elevated entertainment, culminating in The Starlight Reserve.",
  },
];

export const SPONSOR_TIERS = [
  {
    name: "Chairman's Circle",
    amount: "$25,000",
    note: "Exclusive Presenting Sponsor · Limited to one",
    highlight:
      "The name on the first Million Dollar Shot — presenting integration across every 2026 asset, a front-row VIP table of ten, and a private dinner with medical leadership.",
  },
  {
    name: "Visionary Circle",
    amount: "$15,000",
    note: "Five available · industry exclusivity",
    highlight:
      "On-stage brand recognition, category exclusivity within your industry, and a reserved VIP table of eight in premium placement.",
  },
  {
    name: "Benefactor Circle",
    amount: "$10,000",
    note: "Ten available",
    highlight:
      "Co-present the Mission Moment with a dedicated e-blast feature and a reserved VIP table of six.",
  },
  {
    name: "Patron Circle",
    amount: "$5,000",
    note: "A strong presence",
    highlight:
      "Prominent logo placement across the evening with four VIP tickets in premium placement.",
  },
  {
    name: "Advocate Circle",
    amount: "$2,500",
    note: "Founding recognition",
    highlight:
      "Name recognition in the program and signage, with founding-year first right of renewal for 2027.",
  },
];

export const FEATURED_PLACEMENTS = [
  "The Million Dollar Shot",
  "The Starlight Reserve",
  "Red Carpet Experience",
  "Wine",
  "Culinary",
  "Print Media",
  "Entertainment",
  "The Nightcap",
  "Valet",
  "Photography & Videography",
  "The Circle of Distinction",
  "Together We Carry Hope",
];

export const ABOUT = {
  eyebrow: "The Mission That Makes This Evening Matter",
  title: "Naples Cancer Advisors",
  lead:
    "Naples Cancer Advisors is not a typical oncology practice. Patients are never charged for services, and insurance companies are never billed. That structure is intentional.",
  paragraphs: [
    "At the most consequential moment of a cancer journey, every patient deserves clarity, accuracy, and peace of mind. That is why our expert guidance is offered at no cost, with no financial stake in any treatment decision, working hand in hand with each patient's treating oncologist toward one goal: the best possible path forward.",
    "In 2026 alone, more than 11,000 Southwest Florida residents are expected to receive a new diagnosis. Your support does not disappear into overhead. It becomes care in our community, ensuring no patient faces cancer alone.",
  ],
  makesPossible: [
    "Education and advocacy programs delivered across Southwest Florida.",
    "Free, comprehensive second-opinion consultations with experienced oncology experts.",
    "Time with a physician who will sit across from a patient and explain the diagnosis in full.",
    "A compassionate partner walking beside the patient and family at every step of their cancer journey.",
    "Financial navigation services that ease the burden of treatment-related costs.",
  ],
  stats: [
    { value: "$0", label: "Ever charged to a patient" },
    { value: "11,000+", label: "New SWFL diagnoses in 2026" },
    { value: "100%", label: "Of funds to community care" },
  ],
};

export const MARQUEE_WORDS = [
  "Join Us for the Inaugural Million Dollar Shot",
  "An Evening in Service of Hope",
  "Because No One Should Face Cancer Alone",
  "One Night. One Shot. A Lifetime of Impact.",
];
